import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { 
  FaUsers, 
  FaNewspaper, 
  FaDatabase, 
  FaChartBar, 
  FaHistory,
  FaClipboardList,
  FaCog
} from 'react-icons/fa';

function AdminDashboard() {
  //console.log('Rendering AdminDashboard');

  return (
    <div className="p-4">
      <h2 className="mb-4">管理員儀表板</h2>
      
      {/* 用戶管理區域 */}
      <div className="mb-4">
        <h4 className="mb-3 text-primary">
          <FaUsers className="me-2" />
          用戶管理
        </h4>
        <Row>
          <Col md={4}>
            <Link 
              to="/admin/users" 
              className="text-decoration-none"
            >
              <Card
                className="mb-3 dashboard-card" 
                style={{ 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FaUsers className="me-3 text-primary" size={24} />
                  <div>
                    <Card.Title className="mb-2">用戶管理</Card.Title>
                    <Card.Text className="text-muted">
                      管理系統用戶，包括教練和學員
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </div>

      {/* 評估管理區域 */}
      <div className="mb-4">
        <h4 className="mb-3 text-success">
          <FaClipboardList className="me-2" />
          評估管理
        </h4>
        <Row>
          <Col md={4}>
            <Link 
              to="/admin/evaluation-database" 
              className="text-decoration-none"
            >
              <Card
                className="mb-3 dashboard-card" 
                style={{ 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FaDatabase className="me-3 text-success" size={24} />
                  <div>
                    <Card.Title className="mb-2">評估資料庫</Card.Title>
                    <Card.Text className="text-muted">
                      管理評估相關資料庫
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col md={4}>
            <Link 
              to="/admin/instructor-evaluations" 
              className="text-decoration-none"
            >
              <Card
                className="mb-3 dashboard-card" 
                style={{ 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FaChartBar className="me-3 text-success" size={24} />
                  <div>
                    <Card.Title className="mb-2">教練評估</Card.Title>
                    <Card.Text className="text-muted">
                      查看所有教練的評估結果
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col md={4}>
            <Link 
              to="/admin/legacy-evaluations" 
              className="text-decoration-none"
            >
              <Card
                className="mb-3 dashboard-card" 
                style={{ 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FaHistory className="me-3 text-warning" size={24} />
                  <div>
                    <Card.Title className="mb-2">舊評估記錄</Card.Title>
                    <Card.Text className="text-muted">
                      查看24/25雪季舊評估記錄
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </div>

      {/* 內容管理區域 */}
      <div className="mb-4">
        <h4 className="mb-3 text-info">
          <FaNewspaper className="me-2" />
          內容管理
        </h4>
        <Row>
          <Col md={4}>
            <Link 
              to="/articles/manage" 
              className="text-decoration-none"
            >
              <Card
                className="mb-3 dashboard-card" 
                style={{ 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
              >
                <Card.Body className="d-flex align-items-center">
                  <FaNewspaper className="me-3 text-info" size={24} />
                  <div>
                    <Card.Title className="mb-2">文章管理</Card.Title>
                    <Card.Text className="text-muted">
                      管理系統文章
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AdminDashboard; 